const orgInput = document.getElementById('user_organisation_id');
orgInput?.addEventListener('change', async () => {
  const suggestions = document.getElementById('job_name_suggestions');
  if(!suggestions) { return; }

  // Clear previous suggestions
  suggestions.replaceChildren();

  const orgID = orgInput.value;
  if(orgID) {
    const response = await fetch(`/api/filter_jobs?organisation_id=${orgID}`);
    if(response.ok) {
      const json = await response.json();
      for(const job of json.jobs) {
        const option = document.createElement('option');
        option.value = job;
        suggestions.appendChild(option);
      }
    }
  }
});
